export default __webpack_public_path__ + "static/media/icons-publisher.b352582d.svg";